'use strict';
// https://github.com/tc39/proposal-string-pad-start-end
var $export = require('./_export')
  , $pad    = require('./_string-pad');

$export($export.P, 'String', {
  padEnd: function padEnd(maxLength /*, fillString = ' ' */){
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/core-js/modules/es7.string.pad-end.js
// module id = 328
// module chunks = 2 3 4 5 6 7 8 9 10 11 12